import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { USERS_URL } from '../../../../api/users';
import styles from './tenantUsersList.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from '../../../../components/ui/customDataGrid/filterOperators';

export const TenantUsersList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewUsers = useHasPermission("users.view_user");

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: 'first_name',
      headerName: t('First Name'),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: 'last_name',
      headerName: t('Last Name'),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: 'email',
      headerName: t('Email'),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: 'is_active',
      headerName: t('Active'),
      type: 'boolean',
    },
    {
      field: 'group_names',
      headerName: t('Permission Groups'),
      filterable: false,
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(TENANT_ROUTES.user(id));
  };

  if (!canViewUsers) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<PersonIcon />}
        title={t('Users')}
        url={USERS_URL}
        gridSettingsKey="TENANT_USERS"
        columns={columns}
        refreshEventName="tenantUpdated"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
